import {ClientError} from 'graphql-request';
import {getGqlErrorMessage} from '@/api/request';
import {
  BasicAnalysisResult,
  HouseholdItem,
  HouseReportData,
} from '@/map/@types';
import {
  AreaAnalyticsFilter,
  BuildingType,
  SchoolItemKoreanType,
} from '@/map/enums';
import {INVALID_POLYGON_ERROR} from '../constants';

export const computeHouseCount = (items: HouseholdItem[]) => {
  const counts = {
    total: 0,
    [BuildingType.Apartment]: 0,
    [BuildingType.Officetel]: 0,
    [BuildingType.Villa]: 0,
    [BuildingType.HOUSE]: 0,
  };

  items?.forEach(({type, total}) => {
    if (!counts[type]) {
      counts[type] = 0;
    }

    counts[type] += total;
    counts.total += total;
  });

  return counts;
};

export const computeMoveInExpectedHouseCount = (
  items: Array<{count?: number}>
) => {
  return items.reduce((acc, cur) => {
    acc += cur.count ?? 0;
    return acc;
  }, 0);
};

export const getAreahouseReport = (rawdata?: BasicAnalysisResult) => {
  if (!rawdata) {
    return undefined;
  }

  const obj: HouseReportData = {
    [AreaAnalyticsFilter.HOUSE]: {},
  };

  if (rawdata[AreaAnalyticsFilter.HOUSE]) {
    obj[AreaAnalyticsFilter.HOUSE] = computeHouseCount([
      ...rawdata[AreaAnalyticsFilter.HOUSE],
    ]);
  }

  if (rawdata[AreaAnalyticsFilter.UPCOMMING_APTS]) {
    const total = computeMoveInExpectedHouseCount(
      rawdata[AreaAnalyticsFilter.UPCOMMING_APTS]
    );

    obj[AreaAnalyticsFilter.HOUSE][AreaAnalyticsFilter.UPCOMMING_APTS] = total;
  }

  return obj;
};

export const getSalesAvg = (data: any[], key: string) => {
  return data.reduce((acc, cur) => acc + cur[key], 0) / data.length;
};

export const getCompareAvgLevel = (total: number, avg: number) => {
  const percentage = (total / avg) * 100;

  if (percentage > 150) {
    return 2;
  } else if (percentage > 100) {
    return 1;
  } else if (percentage < 30) {
    return -2;
  } else if (percentage <= 50) {
    return -1;
  }

  return 0;
};

export const getSchoolFilterNameByKoreanType = (korType: string) => {
  const key = korType as keyof typeof SchoolItemKoreanType;
  const filter = SchoolItemKoreanType[key] as any;

  return filter as AreaAnalyticsFilter;
};

export const getCompareAvgText = (level: number) => {
  let text = '';
  text += Math.abs(level) === 2 ? '매우 ' : '';
  text += level === 0 ? '비슷함' : level > 0 ? '높음' : '낮음';

  return text;
};

export const getAreaAnalyticsErrorMessage = (error: ClientError | any) => {
  const message = getGqlErrorMessage(error, false);

  if (message?.includes(INVALID_POLYGON_ERROR)) {
    return message;
  }

  return /[ㄱ-힣]/.test(message)
    ? message
    : '일시적인 오류가 발생했습니다.<br />잠시 후 다시 시도해주세요.';
};
